module.exports = __webpack_public_path__ + "img/pcqtdb.41eeacdf.png";